import React from 'react';
import type { NavigationItem } from '@/types';
import NavItem from './NavItem';
import styles from './NavGroup.module.css';

interface NavGroupProps {
  label?: string;
  items: NavigationItem[];
  isCollapsed: boolean;
}

export const NavGroup: React.FC<NavGroupProps> = ({ label, items, isCollapsed }) => {
  if (items.length === 0) return null;

  return (
    <div className={styles.group}>
      {label && !isCollapsed && (
        <div className={styles.header}>
          <span className={styles.title}>{label}</span>
        </div>
      )}
      {label && isCollapsed && (
        <div className={styles.divider} />
      )}
      <ul className={styles.list}>
        {items.map(item => (
          <NavItem 
            key={item.id} 
            item={item} 
            isCollapsed={isCollapsed}
          />
        ))}
      </ul>
    </div>
  );
};

export default NavGroup;
